import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, Column, ExternalLink, LgSpacing, Row, getBrand, useScreenSize } from '@alto/design-system';
import { getYear } from 'date-fns';
import React from 'react';
import styled, { css } from 'styled-components';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS, getPharmacyNoticesUrl, getPrivacyPolicyUrl, getTermsOfServiceUrl } from '~shared/constants';

const FooterPhoneCss = css`
  padding: ${SPACING.STATIC.LG.rem} ${SPACING.STATIC.LG.rem} ${SPACING.STATIC.MD.rem};
`;

const LogoContainer = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  margin-bottom: ${SPACING.STATIC.LG.rem};

  > img {
    height: 100%;
    width: auto;
    display: block;
  }
`;

const StyledFooter = styled.footer<{ isSMScreenOrBigger: boolean; backgroundColor: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${SPACING.STATIC.XL.rem} ${SPACING.STATIC.XL.rem} ${SPACING.STATIC.LG.rem};
  background-color: ${({ backgroundColor }) => backgroundColor};
  ${({ isSMScreenOrBigger }) => !isSMScreenOrBigger && FooterPhoneCss}
`;

const getBackgroundColor = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return COLORS.PALETTE.PRIMARY.DARKEST;
  }

  return COLORS.PALETTE.GREYSCALE.DEFAULT;
};

const getTextColor = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return COLORS.TEXT_COLORS.WHITE;
  }

  return COLORS.TEXT_COLORS.DISABLED;
};

export const Footer = () => {
  const { isSMScreenOrBigger, isMDScreenOrBigger } = useScreenSize();
  const Layout = isMDScreenOrBigger ? Row : Column;

  const backgroundColor = getBackgroundColor();
  const color = getTextColor();

  return (
    <StyledFooter
      isSMScreenOrBigger={isSMScreenOrBigger}
      backgroundColor={backgroundColor}
    >
      <LogoContainer>
        <img
          src={getImage('logoFooter')}
          alt={IMG_ALT_TEXTS.logo}
        />
      </LogoContainer>
      <Layout
        wrap
        spaceBetween
      >
        <Layout wrap>
          <ExternalLink
            color={color}
            href={getPrivacyPolicyUrl()}
            fontFamily="semibold"
          >
            Privacy Policy
          </ExternalLink>
          <LgSpacing />
          <ExternalLink
            color={color}
            href={getPharmacyNoticesUrl()}
            fontFamily="semibold"
          >
            Pharmacy Notices
          </ExternalLink>
          <LgSpacing />
          <ExternalLink
            color={color}
            href={getTermsOfServiceUrl()}
            fontFamily="semibold"
          >
            Terms & Conditions
          </ExternalLink>
          <LgSpacing />
        </Layout>
        <Body
          color={color}
        >{`\u00A9 ${getYear(new Date())} ${getBrand() === 'alto' ? 'Alto Pharmacy' : 'Fuze Health Inc'}. All rights reserved.`}</Body>
      </Layout>
    </StyledFooter>
  );
};
